import { ItemPanier } from '@/store/modules/panier';
import { ReglementCommande } from '@/model/commande/reglement-commande';
import { Commande } from '@/model/commande/commande';
import { LigneCommande } from '@/model/commande/ligne-commande';

export function mapPanierToCommande (numTiers: string, items: ItemPanier[]): Commande {
  const commande = new Commande();
  commande.numTiers = numTiers;
  commande.lignes = (items as ItemPanier[]).map(item => {
    const ligne = new LigneCommande();

    ligne.idLigne = item.idLigne;
    ligne.articleLieuDepart = item.articleLieuDepart;
    ligne.dateDebutLivraison = item.echeanceLivraison;
    ligne.dateFinLivraison = item.echeanceLivraison;

    ligne.qteLivr = item.quantite * item.conditionnement.facteurUniteBase;
    ligne.quantiteUnitaire = item.quantite;
    ligne.codeConditionnement = item.conditionnement.code;
    ligne.adresseLivraison = item.adresse;
    ligne.modeCamion = item.conditionnement.code;

    const reglement = new ReglementCommande();
    reglement.modeReglement = item.modeReglement.codeReglement;
    if (item.domiciliationBancaire) {
      reglement.numDomiciliationBancaire = item.domiciliationBancaire.numDomiciliationBancaire;
      reglement.codeBic = item.domiciliationBancaire.bic;
      reglement.iban = item.domiciliationBancaire.iban;
    }

    reglement.prixUnitaireHT = item.prixUnitaireHT;
    reglement.prixUnitaireTTC = item.prixUnitaireTTC;
    reglement.montantTotalHT = item.prixTotalHT;
    reglement.montantTotalTTC = item.prixTotalTTC;

    reglement.tauxEscompte = item.modeReglement.tauxEscompte;
    reglement.dateEcheance = item.echeancePaiement;

    ligne.reglement = reglement;

    return ligne;
  });

  return commande;
}
